import CoronaBanner from "./MarketingBanner";

export default CoronaBanner;
